import React, { useState } from 'react';
import { Box, CircularProgress, IconButton, Tooltip, Typography } from '@mui/material';
import { Refresh as RefreshIcon } from '@mui/icons-material';
import { formatDistanceToNow } from 'date-fns';
import { axiosService } from 'shared/helpers/axios';

/** "Updated 4 minutes ago ⟳" for the stored analytics figures (interact/analytics/snapshots.py): they are at
 *  most about ten minutes old and refresh by themselves; the button recomputes them now (?fresh=1). */
export default function AsOf({ asOf, url, mutate }) {
  const [busy, setBusy] = useState(false);
  if (!asOf) return null;

  const refresh = async () => {
    setBusy(true);
    try {
      const { data } = await axiosService.get(`${url}${url.includes('?') ? '&' : '?'}fresh=1`);
      mutate(data, { revalidate: false });
    } finally {
      setBusy(false);
    }
  };

  return (
    <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.5 }}>
      <Typography variant="caption" color="text.secondary">
        Updated {formatDistanceToNow(new Date(asOf), { addSuffix: true })}
      </Typography>
      <Tooltip title="Recompute now">
        <span>
          <IconButton size="small" onClick={refresh} disabled={busy} aria-label="Recompute now">
            {busy ? <CircularProgress size={16} /> : <RefreshIcon fontSize="small" />}
          </IconButton>
        </span>
      </Tooltip>
    </Box>
  );
}
